jQuery( document ).ready(function() {
  jQuery("a[data-sub-menu]").click(function(e){
    e.preventDefault();
    e.stopPropagation(); 
    jQuery(this).siblings(".dropdown-menu").toggleClass("show");
  });

  jQuery("button[data-show]").click(function(e){
    e.preventDefault();
    e.stopPropagation(); 
    const selector = jQuery(this).attr("data-show");
    const targetElement = jQuery(selector); 
    
    jQuery(this).toggleClass("target-is-shown");
    targetElement.toggleClass("show");
    const isAddingShow = targetElement.hasClass("show");
    if (isAddingShow) {
        targetElement.find("input").first().focus();
    }
  });

  jQuery(document).on('click', function(e) {
    jQuery("button[data-show]").each(function() {
        const selector = jQuery(this).attr("data-show");
        const targetElement = jQuery(selector);
        // Check if the click target is neither the targetElement nor a descendant of it
        if (!targetElement.is(e.target) && targetElement.has(e.target).length === 0) {
            targetElement.removeClass("show");
            jQuery(this).removeClass("target-is-shown");
        }
    });
  });
});

